import AssignmentIcon from "@mui/icons-material/Assignment";
import permissions from "app/permissions";
import { ACCOMMODATION_ORDERS, DormitoryServicePath } from "utils/constants";
import CreateAccommodationOrder from "./Create";
import EditAccommodationOrder from "./Edit";
import ListAccommodationOrders from "./List";
import ShowAccommodationOrder from "./Show";

export const resources = {
  isMenu: true,
  icon: <AssignmentIcon />,
  name: DormitoryServicePath + ACCOMMODATION_ORDERS,
  title: "Настанителни заповеди",
  recordRepresentation: "number",
  list: <ListAccommodationOrders />,
  show: <ShowAccommodationOrder />,
  create: <CreateAccommodationOrder />,
  edit: <EditAccommodationOrder />,
  permission: permissions.canPreviewDormitoryAccommodationOrders,
  showPermission: permissions.canPreviewDormitoryAccommodationOrders,
  createPermission: permissions.canManageDormitoryAccommodationOrders,
  editPermission: permissions.canManageDormitoryAccommodationOrders,
};
